import Axios from "axios";
import { Button } from "primereact/button";
import { ConfirmDialog, confirmDialog } from "primereact/confirmdialog";
import { InputText } from "primereact/inputtext";
import { useState } from "react";
import { toast } from "react-toastify";
import { mask, unMask } from "remask";
import { setLocal } from "../../../utils/localStorageOps";
import { validaCnpj } from "../../../utils/validacoes";
//import AppCard from "../../../components/appCard";
import { FloatLabel } from "primereact/floatlabel";
//import imagemCover from '../../../assets/Untitled_design(5).png'
import { useNavigate } from "react-router-dom";
import { confirmFooter } from "../../../components/confirmFooter";
import { Api } from "../../../services/api";
import { ButtonPagueDefault } from "../../../styles/primeReactConfig";
//import ValidaCPF from "../../../utils/ValidaCPF";

function CadastroStateCheck() {
  const navigate = useNavigate();
  const [documentoCadastro, setDocumentoCadastro] = useState();
  const [nomeFantasiaCadastro, setNomeFantasiaCadastro] = useState();
  const [loading, setLoading] = useState();

  const consultaCNPJ = async (e) => {
    const cnpj = unMask(e)
    if (cnpj.length === 14) {
      if (validaCnpj(cnpj)) {
        try {
          const { data } = await Axios.get(`https://publica.cnpj.ws/cnpj/${cnpj}`);
          setNomeFantasiaCadastro(data.estabelecimento.nome_fantasia);
          setLocal('cepcadastro', data.estabelecimento.cep);
          toast.success('CNPJ encontrado!');
          if (data.estabelecimento.situacao_cadastral !== "Ativa"){
            // console.log('INATIVA')
            confirmDialog({
              message: `Sua empresa encontra-se em situação ${data.estabelecimento.situacao_cadastral.toUpperCase()} 
                        na Receita Federal para realizar o cadastro em nossa plataforma, é necessário que sua
                        situação cadastral esteja ATIVA`,
              header: 'CNPJ Rejeitado',
              icon: 'pi pi-exclamation-triangle',
              style: {
                heigth: window.innerHeight > 720 ? '40vh' : "90vh",
                width: window.innerWidth > 720 ? '40vw' : "100vw",
                textAlign: 'left',
                borderRadius: '30px',
              },
              //acceptClassName: "outline-green-500 hover:outline-green-600 outline-2 outline bg-green-500 hover:bg-green-600 rounded-md w-full py-3 text-white transition duration-300",
              rejectClassName: 'hidden',
              acceptLabel: "Cadastrar outro CNPJ",
              // reject: () => rejectFunc(),
              accept: () => { setDocumentoCadastro(''); setNomeFantasiaCadastro('') },
              footer: (e) => confirmFooter(e)
            });
          }
        } catch (error) {
          console.log(error);
          try {
            const { data } = await Axios.get(`https://brasilapi.com.br/api/cnpj/v1/${cnpj}`);
            setNomeFantasiaCadastro(data.nome_fantasia);
            setLocal('cepcadastro', data.cep);
            toast.success('CNPJ encontrado!');
          } catch (error) {
            console.log(error);
            toast.error('Nenhum CNPJ encontrado');
          }
        }
      } else {
        toast.error('CNPJ invalido')
      }
    }
  }

  const consultaCadastroStatus = async (event) => {
    event.preventDefault()
    const doc = unMask(documentoCadastro)
    if (doc.length === 14) {
      if (validaCnpj(doc)) {

        setLoading(true)
        try {
          const { data } = await Api.get(`/users/precadastro/${doc}`)
          //console.log(data)
          routerCadastro(data)
        } catch (error) {
          console.log(error)
          toast.error('Erro ao recuperar informações sobre o documento informado');
        } finally {
          setLoading(false)
        }
      } else {
        toast.error('CNPJ Inválido, por favor informe verifique o CNPJ digitado')
      }
    }
    // else
    // if(doc.length === 11 || ValidaCPF(doc)){
    //     setLocal('documentocadastro',unMask(documentoCadastro));
    //     setLocal('nomefantasiacadastro',nomeFantasiaCadastro);
    //     history.push('/cadastro1');
    // }
    else {
      toast.error('Documento com tamanho inválido')
    }
  }

  function routerCadastro(e) {
    // console.log(e)
    switch (e.etapa) {
      case 0:
        setLocal('documentocadastro', unMask(documentoCadastro));
        setLocal('nomefantasiacadastro', nomeFantasiaCadastro);
        // console.log('0')
        navigate("/cadastro/passo1")
        //window.location.reload()
        break;
      case 1:
        setLocal('documentocadastro', unMask(documentoCadastro));
        setLocal('nomefantasiacadastro', nomeFantasiaCadastro);
        // console.log('1')
        navigate("/cadastro/passo1")
        //window.location.reload()
        break;
      case 2:
        setLocal('usuario_id', e.usuario.usuario_id);
        setLocal('documentocadastro', unMask(documentoCadastro));
        setLocal('nomecadastro', e.usuario.usuario_nome);
        // console.log('2')
        navigate("/cadastro/passo2")
        //window.location.reload()
        break;
      //return (<Redirect exact to="/cadastro2"/>);
      case 3:
        setLocal('documentocadastro', unMask(documentoCadastro));
        setLocal('zoop_id', e.zoop_id);
        setLocal('usuario_id', e.usuario_id);
        setLocal('nomecadastro', e.usuario_nome);
        // console.log('3')
        navigate('/cadastro/passo3');
        //window.location.reload()
        break;
        ;
      case 4:
        toast.error('O documento informado já esta cadastrado em nossa plataforma');

        break;
      default:
        toast.error('Erro ao recuperar informações sobre o documento informado');
        break;
    }
  }

  return (
    <>
      <ConfirmDialog/>
      <div className="grid content-center gap-8 -mt-20 h-full">
        <div className="justify-center flex ">
          {/* <ImagemLogo /> */}
        </div>
        <div className="justify-center flex ">
          <div className="w-2/3 ">
            <form onSubmit={(e) => consultaCadastroStatus(e)}>
              <div className="grid text-center w-full gap-7">
                <h1 className="text-2xl"><b>Olá, bem vindo à Direto!</b></h1>
                <h6 className="text-lg">Para começar seu cadastro, preencha os dados abaixo</h6>
                <FloatLabel className="grid">
                  <InputText
                    className="w-full"
                    id="documento"
                    type="text"
                    required
                    value={documentoCadastro}
                    onChange={({ target }) => {
                      setDocumentoCadastro(
                        mask(unMask(target.value), [
                          '99.999.999/9999-99'
                        ])
                      ); consultaCNPJ(target.value)
                    }}

                  />
                  <label htmlFor="documento">CNPJ</label>
                </FloatLabel>

                <FloatLabel className="grid">
                  <InputText
                    className="w-full"
                    id="nome"
                    type="text"
                    required
                    value={nomeFantasiaCadastro}
                    onChange={e => setNomeFantasiaCadastro(e.target.value)}
                  />
                  <label htmlFor="nome">Nome Fantasia/Nome de Usuário</label>
                </FloatLabel>

                <div className="flex justify-center w-full">
                    <Button
                      label="Continuar"
                      pt={ButtonPagueDefault}
                      type="submit"
                      loading={loading}
                    />
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  )
}

export default CadastroStateCheck